<div class="main-page-content container">


  <form [formGroup]="itemFormGroup" (submit)="myFormSubmit($event)" *ngIf="this.token?.refresh_token ">
    <div class="main-page-content-block">
      <h1 class="content-heading-font">My profile</h1>



      <div class="row" *ngIf="user ">
        <div class="col d-flex justify-content-center">
          <img *ngIf="user.ProfileImageURL" class="profileImage d-block" [src]="user.ProfileImageURL" />
          <div *ngIf="!user.ProfileImageURL" class="profileImage d-block bg-primary  text-center" style="height: 96px; width: 96px; font-size: 48px;">{{ this.profileInitials() }}</div>

        </div>
      </div>
      <div class="mt-1 mb-3 d-flex justify-content-center">
        <label class="btn btn-light float-left pointer btn-sm">
          <input type="file" hidden="true" #fileInput accept="image/*" (change)="uploadPicture(fileInput)" />
          Change Picture
          <i *ngIf="loadingPicture" class="pi pi-spin pi-spinner"></i>
        </label>
      </div>

      <div class="row">
        <div class="col mb-3">
          <label for="FirstName">First Name</label>
          <input class="form-control" name="FirstName" formControlName="FirstName" autocomplete="FirstName" placeholder="FirstName" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="LastName">Last Name</label>
          <input class="form-control" name="LastName" formControlName="LastName" autocomplete="LastName" placeholder="LastName" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Email">Email</label>
          <input class="form-control" name="Email" formControlName="Email" autocomplete="Email" placeholder="Email" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="PhoneNumber">Phone Number</label>
          <input class="form-control" name="PhoneNumber" formControlName="PhoneNumber" autocomplete="PhoneNumber" placeholder="PhoneNumber" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="GitHub_Username">GitHub sername </label>
          <input class="form-control" name="GitHub_Username" formControlName="GitHub_Username" placeholder="" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="GitHub_AccessToken">GitHub AccessToken </label>
          <input class="form-control" name="GitHub_AccessToken" formControlName="GitHub_AccessToken" placeholder="" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="NotificationOnNewSupportTicket">Notification On New Support Ticket  </label>
          <select class="form-control" name="NotificationOnNewSupportTicket" formControlName="NotificationOnNewSupportTicket">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="ValidIPAddresses">Valid IP Addresses</label>
          <input class="form-control" name="ValidIPAddresses" formControlName="ValidIPAddresses" placeholder="0.0.0.0" />
        </div>
      </div>
      <div class="row m-2" *ngIf="formError">
        <label style="color: red"> {{formError}}</label>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary" type="submit" id="btnLogin" [class.button-loading]="loading">Save</button>
        </div>
      </div>
    </div>
  </form>  


  <div class="main-page-content-block-secondary  mt-3 " *ngIf="!this.token?.refresh_token  && (this.user?.HasOneTimePasswordKey || this.user?.WebAuthnCredentialId) ">
    <h1 class="content-heading-font">Validate your 2-factor authentication</h1>

    <div class="row" *ngIf="this.user?.HasOneTimePasswordKey ">
      <div class="col mb-3">
        <label for="OneTimePassword">Enter the one-time password generated by your authentication app</label>
        <input class="form-control" name="OneTimePassword" autocomplete="one-time-code" placeholder="6 digit code" [(ngModel)]="OneTimePassword" />
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <button class="btn btn-lg btn-primary ms-2" type="button" id="btnVerifyOneTimePassword" [class.button-loading]="loading" *ngIf="this.user?.HasOneTimePasswordKey " (click)="verifyOneTimePassword()">Verify code</button>
        <button class="btn btn-lg btn-secondary  ms-2" type="button" id="btnSendOneTimePassword" [class.button-loading]="loading" *ngIf="this.user?.HasOneTimePasswordKey && this.user?.PhoneNumber" (click)="sendCodePerSMS()">Send per SMS</button>
        <button class="btn btn-lg btn-info ms-2 d-none" type="button" id="btnWebAuthnKey" [class.button-loading]="loading" *ngIf="this.user?.WebAuthnCredentialId " (click)="verifyWebAuthn()">Web Authn</button>
      </div>
    </div>
  </div>

  <div class="main-page-content-block-secondary  mt-3 " *ngIf="!this.showRegister2factor && this.token?.refresh_token  && (this.user?.HasOneTimePasswordKey || this.user?.WebAuthnCredentialId) ">

    <h1 class="content-heading-font">2-factor Authentication</h1>

    <p>
      Has One Time Password Key : <span class="text-success" *ngIf="this.user?.HasOneTimePasswordKey">Yes</span><span class="text-danger" *ngIf="!this.user?.HasOneTimePasswordKey">No</span><br />
      Has Web Authn Key : <span class="text-success" *ngIf="this.user?.WebAuthnCredentialId">Yes</span><span class="text-danger" *ngIf="!this.user?.WebAuthnCredentialId">No</span><br />
    </p>
    <p  *ngIf="this.token?.refresh_token ">
      Token: {{this.token?.refresh_token}}<br />
      Expires: {{this.token?.refresh_expires_at | date:'medium' }}<br />
    </p>

    <div class="row">
      <div class="col text-center">
        <button class="btn btn-lg btn-primary ms-2" type="button" id="btnRenewToken" [class.button-loading]="loading" *ngIf="this.token?.refresh_token " (click)="renewToken()">Renew Token</button>
        <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnReset2Factor" [class.button-loading]="loading" *ngIf="this.user?.HasOneTimePasswordKey" (click)="reset2Factor()">Reset 2-factor</button>
      </div>
    </div>
  </div>
  <div class="main-page-content-block-secondary  mt-3 " *ngIf="this.showRegister2factor || (!this.token?.refresh_token  && !this.user?.HasOneTimePasswordKey && !this.user?.WebAuthnCredentialId)">

    <h1 class="content-heading-font">Register your 2-factor authentication</h1>

    <div>

      <label for="txtOnetimePassword">
        Please register the QR code in the your authentication application
      </label>
      <div class="row" *ngIf="this.OneTimePasswordUri" >
        <div class="col justify-content-center ">
          <a  [href]="OneTimePasswordUri">
            <qrcode [qrdata]="this.OneTimePasswordUri" [width]="500" [errorCorrectionLevel]="'M'"></qrcode><br>
          </a>
        </div>
      </div>


      <div class="row">
        <div class="col mb-3">
          <label for="OneTimePasswordConfirm">Confirm the one-time password</label>
          <input class="form-control" name="OneTimePasswordConfirm" autocomplete="one-time-code" [(ngModel)]="OneTimePasswordConfirm" />
        </div>
      </div>

      <div class="row">
        <div class="col mb-3">
          <label for="WebAuthnkeyInfo">Your Web Authn key</label>
          <input class="form-control" name="WebAuthnkeyInfo" autocomplete="WebAuthnkeyInfo" [(ngModel)]="WebAuthnkeyInfo"  readonly="readonly"/>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary " type="button" id="btnRegisterKeys" [class.button-loading]="loading"  (click)="registerKeys()">Confirm</button>
        </div>
      </div>
    </div>
</div>
